/**
 * Source-of-truth mapping of which reporting questions render under each
 * data-analytics tab, plus their display colours.
 *
 * Tab membership is an explicit questionId list (not tag-based): the same
 * rendering pipeline works for any question, so a newly-created derived
 * question "just works" once its id is appended to the relevant list.
 */

/** Bio-Medical Waste questions (Yellow, Red, White, Blue, Cytotoxic).
 *  Append derived-question ids (e.g. Total / Per-Bed-Per-Day) here as they are created. */
export const BIOMEDICAL_QUESTION_IDS = [9908, 9909, 9910, 9911, 9912, 10145, 10146];

/** Water Management questions (Ground / Surface / Waste-Water Treated).
 *  Consumed by the Water tab follow-up; append new water question ids here. */
export const WATER_QUESTION_IDS = [6707, 6706, 6709, 10053, 6712, 10147];

/** Category dot colour per questionId. Unlisted questions fall back to grey. */
export const CATEGORY_COLORS = {
  9908: "#FFD700",
  9909: "#F44336",
  9910: "#9E9E9E",
  9911: "#2196F3",
  9912: "#9C27B0",
  6707: "#2196F3",
  6706: "#2196F3",
  6712: "#00BCD4",
};

/** Fallback colour for any question without an explicit entry in CATEGORY_COLORS. */
export const CATEGORY_COLOR_FALLBACK = "#9E9E9E";
